import { RESET_PANEL_OPENED_STATE, UPDATE_PANEL_OPENED_STATE } from "../actionTypes/sidepanel";

export const updateSidePanelAction = payload => ({ type: UPDATE_PANEL_OPENED_STATE, payload });
export const resetSidePanelAction = () => ({ type: RESET_PANEL_OPENED_STATE });
